<template>
    <div>
        <div class="top-bar com-model m-b-15">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item :to="{ path: '/index/home' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>公告通知</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="com-model">
            <template v-if="total">
                <div>
                <div class="notice-item" v-for="item in list" :key="item.id">
                    <div class="notice-title">{{item.title}}</div>
                    <div class="notice-content">{{item.content}}</div>
                    <div class="flex flex-between">
                        <div class="flex">
                            <div class="pub-name">{{item.publishUsername}}</div>
                            <div class="pub-time">{{item.createdAt}}</div>
                        </div>
                        <!-- <router-link :to="{ path: '/index/home/notice/detail', query: { id: item.id } }" class="primary-btn">查看详情</router-link> -->
                        <div class="primary-btn" @click="handleDetail(item)">查看详情</div>
                    </div>
                </div>
                </div>
                <el-pagination
                    v-show="total"
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="pageNum"
                    :page-sizes="[5, 10, 20, 30, 40]"
                    :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total" style="margin-top: 40px; padding-bottom: 40px">
                </el-pagination>
            </template>
            <no-data v-else></no-data>
        </div>
    </div>
</template>
<script>
import NoData from '../../components/NoData.vue'
export default {
    components: { NoData },
    data () {
        return {
            pageSize: 5,
            pageNum: 1,
            list: [],
            total: null
        }
    },
    mounted () {
        this.getList()
    },
    methods: {
        handleSizeChange (val){
            this.pageSize = val
            this.getList();
        },
        handleCurrentChange(val) {
            this.pageNum = val;
            this.getList();
        },
        getList () {
            this.axios.get(`/wapi/notice/list?pageNum=${this.pageNum}&pageSize=${this.pageSize}`).then(res => {
                this.list = res.rows;
                this.total = res.total
            })
        },
        handleDetail (item) {
            sessionStorage.setItem('noticeDetail', JSON.stringify(item))
            this.$router.push({ path: '/index/home/notice/detail', query: { id: item.id } })
        }
    }
}
</script>
<style lang="less" scoped>
@import url('../../assets/less/base.less');
.top-bar {
    padding: 22px 24px;
    line-height: 30px;
}
.com-model {
    border-radius: 10px;
}
.notice-item{
    padding: 35px 82px 36px 27px;
    border-bottom: 1px solid #D2D2D2;
    &:last-of-type{
        border-bottom: none;
    }
    .notice-title{
        font-size: 20px;
        color: rgba(0, 0, 0, 0.85);
        font-weight: 500;
        line-height: 28px;
        margin-bottom: 28px;
    }
    .notice-content{
        font-weight: 400;
        color: #333333;
        line-height: 22px;
        font-size: 16px;
        margin-bottom: 20px;
    }
    .pub-name{
        font-weight: 400;
        color: #555555;
        line-height: 20px;
        font-size: 14px;
        margin-right: 30px;
    }
    .pub-time{
        font-weight: 400;
        color: #999999;
        line-height: 20px;
        font-size: 14px;
    }
    .primary-btn{
        width: 120px;
    }
}
</style>



// WEBPACK FOOTER //
// list.vue?38a17f3f